import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';
import { NavLink } from 'react-router-dom';

import ArrowIcon from '@/assets/icons/right-arrow.svg?react';
import { useTranslator } from '@/hooks/useTranslator';
import { useVerifyBusinessSteps } from '@/hooks/useVerifyBusinessSteps';
import { ChildStep, ParentStep } from '@/types/steps';
import { computeSummaryPath } from '@/utility/computeSummaryPath';

export const VerifyBusinessSummaryMenu: React.FC = (): React.ReactElement => {
  const steps = useVerifyBusinessSteps();
  const tr = useTranslator();

  return (
    <Box px={5} pt={3}>
      <List disablePadding={true}>
        {steps.map((parent: ParentStep<unknown>): React.ReactNode => {
          const { children } = parent;

          return children.map((child: ChildStep<unknown>): React.ReactElement => {
            return (
              <ListItem
                key={child.path}
                sx={styles.listItem}
                disableGutters={true}
                disablePadding={true}>
                <NavLink to={computeSummaryPath(parent, child)}>
                  {({ isActive }: { readonly isActive: boolean }): React.ReactNode => {
                    const style = isActive ? [styles.link, styles.active] : styles.link;

                    return (
                      <Box sx={style}>
                        <Typography color="inherit" variant="h7">
                          {tr(child.title)}
                        </Typography>
                        {isActive ? <ArrowIcon /> : null}
                      </Box>
                    );
                  }}
                </NavLink>
              </ListItem>
            );
          });
        })}
      </List>
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  listItem: {
    borderBottom: '1px solid #E5E5E5',
    '&:last-child': {
      borderBottom: 'none',
    },
    a: {
      width: '100%',
    },
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 72,
    width: '100%',
    color: 'custom.LightGray',
  },
  active: {
    color: 'text.primary',
  },
};
